import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=6f5ec358&scoped=true&"
import script from "./MenuTable.vue?vue&type=script&lang=js&"
export * from "./MenuTable.vue?vue&type=script&lang=js&"
import style0 from "./MenuTable.vue?vue&type=style&index=0&id=6f5ec358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ec358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
